var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Accordion from '@marketing/components/global/misc/Accordion';
function FAQAccordion(_a) {
    var question = _a.question, answer = _a.answer;
    return (_jsx(Accordion, __assign({ title: question, detailsClassName: "border border-state-inactive-light rounded-md bg-surface-white transition-[border-color] ease-in-out md:hover:border-bone-300", summaryClassName: "px-xs-m py-lg-m", buttonTheme: "gray" }, { children: _jsx("div", __assign({ className: "px-xs-m pb-lg-m text-sm-reg-m md:text-sm-reg-d" }, { children: answer })) })));
}
export default FAQAccordion;
